import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@flexyoo/auth';

@Injectable()
export class AuthGuard {
  constructor(protected router: Router, private auth: AuthenticationService) {}

  canActivate(): Observable<boolean> | boolean {
    const user = this.auth.getCurrentUser();

    if (!user) {
      this.auth.logout();
      return false;
    }
    return true;
  }
}
